import {
  Box,
  Input,
  Link,
  Chip,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TextField,
  Typography
} from '@material-ui/core';
import React from 'react';
import KenDateTimePicker from '../../global_components/KenDateTimePicker';
import { facultyDropDown } from '../../Pages/AdminPortal/Exam/Invigilation/InvigilationAssign';
import KenSelect from '../../global_components/KenSelect';
import KenSelectWrap from '../../global_components/KenSelect';
import KenCheckbox from '../../global_components/KenCheckbox/index';
import KenAutoComplete from '../../global_components/KenAutoComplete/index';
import KenInputField from '../KenInputField';
import moment from 'moment';

const kenGridEditable = ({
  row,
  name,
  onChange,
  onHyperClick,
  editCell,
  selectedRow,
  type,
  columns,
  rowName,
  dropdown,
  onAutoCompleteClick,
  dateValidate,
}) => {
  const { isEditMode } = row;

  return columns.map((ele, index) => {
    if (ele.inline_edit_type == 'kenDatePicker') {
      return (
        <TableCell align="left">
          {isEditMode ? (
            <>
              <KenDateTimePicker
                name={ele.column_name}
                label={ele.label}
                placeholder="Start Date"
                value={ele.disableMin ? undefined : row[ele.column_name]}
                minDate={ele.disableMin ? undefined : row[ele.min_date]}
                type="date"
                required={true}
                inputFormat="YYYY-MM-DD"
                onChange={(e) => onChange(e, row)}
              />
              {ele.column_name === 'endDate' && ele.errorNote != '' ? (
                <p style={{ color: 'red' }}>{ele.errorNote}</p>
              ) : null}
            </>
          ) : row[ele.column_name] ? (
            moment(row[ele.column_name]).format('DD-MM-YYYY')
          ) : (
            ''
          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type === 'kenDatePicker1') {
      return (
        <TableCell align="left">
          {isEditMode ? (
            <>
              <KenDateTimePicker
                name={ele.column_name}
                label={ele.label}
                placeholder="Start Date"
                value={row[ele.column_name]}
                minDate={ele.min_date}
                maxDate={ele.max_date}
                type="date"
                required={true}
                inputFormat="YYYY-MM-DD"
                onChange={(e) => onChange(e, row)}
              />
              {ele.column_name === 'endDate' && ele.errorNote != '' ? (
                <p style={{ color: 'red' }}>{ele.errorNote}</p>
              ) : null}

              {dateValidate &&
                ele.column_name === 'startDate' &&
                row[ele.column_name] === null && (
                  <p style={{ color: 'red' }}>{dateValidate}</p>
                )}

              {dateValidate &&
                ele.column_name === 'endDate' &&
                row[ele.column_name] === null && (
                  <p style={{ color: 'red' }}>{dateValidate}</p>
                )}
            </>
          ) : row[ele.column_name] ? (
            moment(row[ele.column_name]).format('DD-MM-YYYY')
          ) : (
            ''
          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type === 'kenTime') {
      if (isEditMode) {
        if (ele.column_name === 'start_time') {
          const start_time = moment(row[ele.column_name], ['h:mm A']).format(
            'HH:mm:ss'
          );

          row[ele.column_name] = start_time;
        }
        if (ele.column_name === 'end_time') {
          const end_time = moment(row[ele.column_name], ['h:mm A']).format(
            'HH:mm:ss'
          );
          row[ele.column_name] = end_time;
        }
      }
      return (
        <TableCell align="left">
          {isEditMode ? (
            <>
              <KenDateTimePicker
                name={ele.column_name}
                label={ele.label}
                placeholder={ele.label}
                value={row[ele.column_name]}
                type="time"
                required={true}
                onChange={(e) => onChange(e, row)}
              />
            </>
          ) : (
            row[ele.column_name]
          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type == 'kenSelect') {
      return (
        <TableCell align="left">
          {isEditMode ? (
            <Box style={{ width: '25vh' }}>
              <KenSelect
                name={ele.column_name}
                options={ele.dropdown}
                value={row[ele.column_name]}
                dropdownColor="#ffffff"
                onChange={(e) => onChange(e, row)}
                required={true}
                disabled={ele.disableDropdown}
                label={ele.label}
              />
            </Box>
          ) : ele.statusOption != undefined ? (
            <p style={{ background: row.statusColor, padding: '10px', width: '85px', textAlign: 'center', borderRadius: '8px' }}>{row[ele.column_name]}</p>
          ) : (
            row[ele.column_name]
          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type == 'kenSelect1') {
      let val = ele.dropdown.filter((item) => {
        if (row[ele.column_name] != null) {
          if (item.value === row[ele.column_name]) {
            return item;
          }
        }
      });
      return (
        <TableCell align="left">
          {isEditMode ? (
            <Box style={{ width: '25vh' }}>
              <KenSelect
                name={ele.column_name}
                options={ele.dropdown}
                value={row[ele.column_name]}
                dropdownColor="#ffffff"
                onChange={(e) => onChange(e, row)}
                required={true}
                disabled={ele.disableDropdown}
                label={ele.label}
              />
            </Box>
          ) : (
            val[0]?.label
          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type == 'kenAutoComplete') {
      return (
        <TableCell>
          {isEditMode ? (
            <Box style={{ width: '25vh' }}>
              {ele?.hyperLink != undefined ? (
                <a
                  style={{ cursor: 'pointer', textAlign: 'center' }}
                  onClick={(e, value) => onHyperClick(e, row, value)}
                >
                  {ele.hyperLink}
                </a>
              ) : null}
              <KenAutoComplete
                options={ele.dropdown}
                value={row?.facultyList}
                disabled={isEditMode != undefined && isEditMode ? false : true}
                variant="outlined"
                onChange={(e, value) => onChange(e, row, value)}
                required
              />
            </Box>
          ) : (
            <span>
              {row[ele.column_name] != undefined &&
                row[ele.column_name].length > 0
                ? row[ele.column_name]?.map((item) => {
                  return (
                    <Chip
                      style={{ marginBottom: 3 }}
                      label={`${item?.facultyName || item?.title}`}
                      onClick={() => {
                        onAutoCompleteClick(item);
                      }}
                    />
                  );
                })
                : null}
            </span>
          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type == 'kenInput') {
      return (
        <TableCell align="left">
          {isEditMode ? (
            <TextField
              value={row[ele.column_name]}
              name={ele.column_name}
              onChange={(e) => onChange(e, row)}
            />
          ) : (
            <Typography>{row[ele.column_name]}</Typography>

          )}
        </TableCell>
      );
    } else if (ele.inline_edit_type === 'linkItem') {
      return (
        <TableCell
          align="left"
          style={
            row.activity === 'N/A' || row.section === 'N/A'
              ? { color: '#000' }
              : { color: '#242f9b', cursor: 'pointer' }
          }
          onClick={(e) =>
            row.activity === 'N/A' || row.section === 'N/A'
              ? null
              : editCell(ele.column_name, row, ele.selectedRow)
          }
        >
          {row[ele.column_name]}
        </TableCell>
      );
    } else if (ele.inline_edit_type === 'kenCheckbox') {
      return (
        <TableCell align="left" style={{ width: '30px' }}>
          <KenCheckbox
            name={ele.column_name}
            value={row.checked}
            onChange={(e) => onChange(e, row)}
            color="primary"
          />
        </TableCell>
      );
    } else {
      return <TableCell>{row[ele.column_name]}</TableCell>;
    }
  });
};

export default kenGridEditable;
